var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M424,41c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S565.4,41,424,41z M552.4,236.9v34.7\r\n\tc-16.3,0-32.2-3.2-47.2-9.5c-9.6-4.1-18.6-9.3-26.8-15.6l0.2,106.7c-0.1,24-9.6,46.6-26.8,63.6c-14,13.8-31.7,22.6-51,25.5\r\n\tc-4.5,0.7-9.1,1-13.8,1c-20.6,0-40.1-6.7-56.1-19c-3-2.3-5.9-4.8-8.6-7.5c-18.6-18.4-28.3-43.4-26.6-69.7c1.2-20,9.2-39.1,22.6-54\r\n\tc17.7-19.8,42.4-30.8,68.8-30.8c4.6,0,9.2,0.3,13.8,1v12.8v35.7c-4.3-1.4-8.9-2.2-13.6-2.2c-24.1,0-43.7,19.7-43.3,43.8\r\n\tc0.2,15.5,8.7,29,21.1,36.4c5.9,3.5,12.6,5.7,19.8,6.1c5.6,0.3,11-0.5,16-2.1c17.2-5.7,29.7-21.9,29.7-41l0.1-71.4V150.8h47.7\r\n\tc0,4.7,0.5,9.3,1.4,13.8c3.6,18.1,13.8,33.8,28,44.5c12.4,9.3,27.8,14.9,44.5,14.9c0,0,0.1,0,0.1,0L552.4,236.9L552.4,236.9z"}));
}

Tiktok.displayName = "Tiktok";

Tiktok.defaultProps = {"version":"1.0","x":"0px","y":"0px","viewBox":"0 0 848 594","style":{"enableBackground":"new 0 0 848 594"},"xmlSpace":"preserve"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
